const FrequencyText = (props) => {
  const { frequency } = props;

  if (!frequency) {
    return null;
  }

  return <Month frequency={frequency} />;
};

const Month = (props) => {
  const { frequency } = props;
  switch (frequency) {
    case 1: {
      return 'Every Month';
    }
    case 2: {
      return 'Every 2 Months';
    }
    case 3: {
      return 'Every 3 Months';
    }
    case 4: {
      return 'Every 4 Months';
    }
    case 6: {
      return 'Every 6 Months';
    }
    case 12: {
      return 'Every 12 Months';
    }
    default: {
      throw new Error('Invalid frequency');
    }
  }
};

export default FrequencyText;
